import { createAction } from 'redux-actions'

import * as Services from 'Services'
import * as findputter from 'state/findputter'
import { clearPutter } from './customize'
import { createTrackedAction} from '../../util/analytics'

const START_LOAD = 'sc/findputter/START_LOAD';
const LOAD = 'sc/findputter/LOAD';
const FILTER_TEXT = 'sc/findputter/FILTER_TEXT';
const FILTER_CATEGORY = 'sc/findputter/FILTER_CATEGORY';

const initialState = findputter.initialState;

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case START_LOAD:
      return {
        ...state,
        loading:true,
      }
    case LOAD:
      return {
        ...(action.error)? state : findputter.setPutters(state, action.payload),
        loading:false,
      }
    case FILTER_TEXT:
      return findputter.setPutterFilterText(state, action.payload);
    case FILTER_CATEGORY:
      return findputter.setPutterFilterCategory(state, action.payload);
    default:
      return state;
  }
}

const startLoad = createAction(START_LOAD);
const performLoadPutters = createAction(LOAD, Services.getPutterModels);
export const loadPutters =()=>{
  return (dispatch, getState) =>{
    dispatch(clearPutter());
    dispatch(startLoad());
    dispatch(performLoadPutters())
  }
};

export const setPutterFilterText = createTrackedAction(FILTER_TEXT, null, {
  analyticsDataFcn : (action) => "FindPutter Search:" + action.payload,
  debounce: 500
 });
 
 export const setPutterFilterCategory = createTrackedAction(FILTER_CATEGORY, null, {
  analyticsDataFcn : (action) => "FindPutter Category:" + action.payload,
  debounce: 500
 });